import { InjectionToken } from "@angular/core";
import { ErrorParser } from "../ErrorParser";

export const ErrorParserToken = new InjectionToken<ErrorParser>("ErrorParserToken");
